export default [
  {
    path: '/asset',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '/asset/',
        name: 'assetManagement',
        component: () => import('@/views/Asset/AssetManagement.vue'),
        children: [
          {
            path: '',
            redirect: { name: 'assetList' }
          },
          {
            path: 'assetList',
            name: 'assetList',
            component: () => import('@/views/Asset/AssetList.vue'),
            meta: {
              prev: 'BAHome',
              keepAlive: true
            }
          },
          {
            path: 'consumableList',
            name: 'consumableList',
            component: () => import('@/views/Asset/ConsumableList.vue'),
            meta: {
              prev: 'BAHome'
            }
          },
          {
            path: 'maintenance',
            name: 'maintenance',
            component: () => import('@/views/Asset/Maintenance.vue'),
            meta: {
              prev: 'goHome'
            }
          }
        ]
      },
      {
        path: 'assetEdit',
        name: 'assetEdit',
        component: () => import('@/views/Asset/AssetEdit.vue'),
        meta: {
          prev: 'assetList'
        }
      },
      {
        path: 'maintenance/budget/:selectedYears',
        component: () => import('@/views/Asset/Budget.vue'),
        meta: {
          prev: 'assetManagement'
        },
        children: [
          {
            path: '',
            redirect: {
              name: 'changeBudget'
            }
          },
          {
            path: 'changeBudget',
            name: 'changeBudget',
            component: () => import('@/views/Asset/components/ChangeBudget.vue'),
            meta: {
              prev: 'maintenance'
            }
          },
          {
            path: 'maintenanceBudget',
            name: 'maintenanceBudget',
            component: () => import('@/views/Asset/components/MaintenanceBudget.vue'),
            meta: {
              prev: 'maintenance'
            }
          },
          {
            path: '*',
            redirect: {
              name: 'maintenance'
            }
          }
        ]
      },
      {
        path: 'maintenance/project',
        component: () => import('@/views/Asset/MaintenanceProject.vue'),
        meta: {
          prev: 'maintenance'
        },
        children: [
          {
            path: '',
            redirect: 'detail'
          },
          {
            path: 'detail',
            name: 'maintenanceProjectDetail',
            component: () => import('@/views/Asset/components/MaintenanceProjectDetail.vue'),
            meta: {
              prev: 'maintenance'
            }
          },
          {
            path: 'detail/:planId',
            name: 'maintenanceProjectDetailWithPlanId',
            component: () => import('@/views/Asset/components/MaintenanceProjectDetail.vue'),
            meta: {
              prev: 'maintenance'
            }
          },
          {
            path: 'record/:planId',
            name: 'maintenanceProjectRecord',
            component: () => import('@/views/Asset/components/MaintenanceProjectRecord.vue'),
            meta: {
              prev: 'maintenance'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/asset/assetQRcode',
    component: () => import('@/views/Asset/AssetQRcode.vue')
  }
]
